@defer {
<div class="ticker" #parent style="--width: -137%" [appStoryblok]="_editable">
  <div class="ticker-item" #element>
    <ng-container *ngFor="let blok of images">
      <ndc-dynamic
        *ngIf="components"
        [ndcDynamicComponent]="components[blok.component]"
        [ndcDynamicInputs]="blok"
      >
      </ndc-dynamic
    ></ng-container>
  </div>
  <div class="ticker-item">
    <ng-container *ngFor="let blok of images">
      <ndc-dynamic
        *ngIf="components"
        [ndcDynamicComponent]="components[blok.component]"
        [ndcDynamicInputs]="blok"
      >
      </ndc-dynamic
    ></ng-container>
  </div>
</div>
} @placeholder {}
